import React from "react";
import { CredentialProps } from "../CredentialProps";
import { CredentialLayout } from '../CredentialLayout';
import { CredentialEntities } from "../CredentialEntities";
import { NSARouterMakerProps } from "namirasoft-account-react";

interface GCPListPageProps extends NSARouterMakerProps, CredentialProps { }

export default class GCPListPage extends React.Component<GCPListPageProps>
{
	override render()
	{
		return (
			<CredentialLayout
				{...this.props}
				action={{
					title: "",
					description: "List of all the GCP credentails.",
					menus: {}
				}}
				pages={{
					entity: CredentialEntities.gcp(this.props),
					list: {
						ui: {}
					}
				}}
			>
				<></>
			</CredentialLayout >
		);
	}
}